import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "./App";
import "./styles/global.scss";
import ErrorBoundary from "./componets/ErrorBoundary/ErrorBoundary";
import { ColorProvider } from "./core/ColorProvider";
import { HelpProvider } from "./core/help/HelpContext";

ReactDOM.render(
  <ErrorBoundary>
    <ColorProvider>
      <HelpProvider>
        <HashRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
          <App />
        </HashRouter>
      </HelpProvider>
    </ColorProvider>
  </ErrorBoundary>,
  document.getElementById("root")
);
